import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Authenticated from "../components/Authenticated";
import PilotEventRegistrationList from "../components/PilotEventRegistrationList";

const MyEvents = () => {


    return (
        <Authenticated>
            <Container maxWidth={'md'}>
                <Box textAlign={'left'}>
                    <Typography variant={'h2'} my={4}>My events</Typography>
                    <PilotEventRegistrationList/>
                </Box>
            </Container>
        </Authenticated>
    );
};

export default MyEvents;